import { createContext, useContext, useState, useEffect } from 'react'

// Display-only currency conversion. Tebex prices are native USD; the other
// currencies are APPROXIMATE conversions for browsing convenience — checkout is
// still processed by Tebex in USD. Rates are hand-set (update as needed).
export const CURRENCIES = [
  { code: 'USD', symbol: '$', rate: 1, note: 'NATIVE' },
  { code: 'EUR', symbol: '€', rate: 0.92, note: 'APPROX' },
  { code: 'GBP', symbol: '£', rate: 0.79, note: 'APPROX' },
  { code: 'CAD', symbol: 'CA$', rate: 1.37, note: 'APPROX' },
  { code: 'AUD', symbol: 'A$', rate: 1.52, note: 'APPROX' },
]

const CurrencyContext = createContext(null)
export const useCurrency = () => useContext(CurrencyContext)

export function CurrencyProvider({ children }) {
  const [code, setCode] = useState(() => {
    try { return localStorage.getItem('storeCurrency') || 'USD' } catch { return 'USD' }
  })
  useEffect(() => { try { localStorage.setItem('storeCurrency', code) } catch { /* ignore */ } }, [code])

  const currency = CURRENCIES.find((c) => c.code === code) || CURRENCIES[0]

  // Format a USD amount in the selected currency (converting via the approx rate).
  const format = (usd) => {
    if (usd == null) return ''
    const value = usd * currency.rate
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency.code }).format(value)
    } catch {
      return `${currency.symbol}${value.toFixed(2)}`
    }
  }

  const value = {
    currency,
    currencies: CURRENCIES,
    setCurrencyCode: setCode,
    format,
    isApprox: currency.note !== 'NATIVE',
  }
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>
}
